import { PopupType } from "src/app/shared/enums/popup-types";
import Swal from "sweetalert2";

export function showMessage(
  type = PopupType.Primary,
  msg = "Example notification text.",
  showCloseButton = true,
  duration = 3000,
) {
  const toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: duration,
    customClass: {
      popup: type,
    },
    width: "35rem",
    showCloseButton,
  });
  toast.fire({
    title: msg,
  });
}
